export const shopSurfaceBasePath = (surface?: string): string | undefined =>
  surface ? `/shop/${surface}` : undefined;
